module.exports = __webpack_public_path__ + "img/ubuntu.d4f06438.svg";